<template>
    <div class="pennant-create">
        <div class="contain">
            <div class="type-wrap">
                <div class="title">感谢类型</div>
                <div class="select">
                    <div
                        class="item"
                        :class="{ active: active == item.type }"
                        v-for="(item, index) in types"
                        :key="index"
                        @click="active = item.type"
                    >
                        <img :src="item.img" alt="" />
                        <span>{{ item.name }}</span>
                    </div>
                </div>
            </div>
            <div class="gift">
                <div class="title">
                    {{ active == 1 ? '锦旗文案' : '感谢语' }}
                </div>
                <template v-if="active == 1">
                    <div class="select">
                        <div
                            class="item"
                            v-for="(item, index) in editorList"
                            :key="index"
                            @click="current = item.id"
                        >
                            <van-checkbox
                                :value="getSelect(item.id)"
                                icon-size="16"
                            >
                                {{ item.name }}
                            </van-checkbox>
                        </div>
                    </div>
                </template>
                <template v-else-if="active == 2">
                    <div class="descript">
                        <van-field
                            v-model="content"
                            rows="4"
                            autosize
                            maxlength="50"
                            show-word-limit
                            type="textarea"
                            placeholder="说句话表达您对医生的感谢吧～（50字以内）"
                        />
                    </div>
                </template>
                <div class="editor">
                    <div class="input">
                        <van-icon name="edit" size="18" />
                        <input
                            type="text"
                            v-model="patientName"
                            placeholder="输入赠送人姓名"
                        />
                        
                    </div>
                </div>
            </div>
        </div>

        <div class="confirm-btn">
            <van-button class="action-button" block @click="submit">
                支付¥{{ payMoney }}.00发送心意
            </van-button>
        </div>
    </div>
</template>

<script>
import api_recipe from '../../services/recipe';
import { Toast as VanToast } from 'vant';
import Vue from 'vue';
import { Checkbox, Icon, Field } from 'vant';

Vue.use(Checkbox).use(Icon).use(Field).use(VanToast);

export default {
    name: 'pennantCreate',
    data() {
        return {
            active: 1,
            types: [
                {
                    name: '锦旗',
                    type: 1,
                    img: require('@/assets/images/pennant-type.png'),
                },
                {
                    name: '花花',
                    type: 2,
                    img: require('@/assets/images/flow-icon.png'),
                },
            ],
            current: 1,
            editorList: [
                { id: 1, name: '妙手回春，悬壶济世' , imgUrl:'http://ooso.oss-cn-hangzhou.aliyuncs.com/a9a21480-2078-11ee-b8f9-a7e1d473d0df.png'},
                { id: 2, name: '医德高尚，救死扶伤' ,imgUrl:'http://ooso.oss-cn-hangzhou.aliyuncs.com/c13b7e10-2078-11ee-b8f9-a7e1d473d0df.png'},
                { id: 3, name: '救死扶伤，华佗再世' ,imgUrl:'http://ooso.oss-cn-hangzhou.aliyuncs.com/0c7cef31-2079-11ee-b8f9-a7e1d473d0df.png'},
                { id: 4, name: '医德为玉，医术为金' ,imgUrl:'http://ooso.oss-cn-hangzhou.aliyuncs.com/ce9dda80-2078-11ee-b8f9-a7e1d473d0df.png'},
                { id: 5, name: '慈心妙手，药除疾根',imgUrl:'http://ooso.oss-cn-hangzhou.aliyuncs.com/e02e2930-2078-11ee-b8f9-a7e1d473d0df.png' },
                { id: 6, name: '医以济世，术贵乎精',imgUrl:'http://ooso.oss-cn-hangzhou.aliyuncs.com/e99737f0-2078-11ee-b8f9-a7e1d473d0df.png' },
                { id: 7, name: '华佗在世，扁鹊重现' ,imgUrl:'http://ooso.oss-cn-hangzhou.aliyuncs.com/f4bc75a0-2078-11ee-b8f9-a7e1d473d0df.png'},
                { id: 8, name: '光明天使，济世良医',imgUrl:'http://ooso.oss-cn-hangzhou.aliyuncs.com/039608c0-2079-11ee-b8f9-a7e1d473d0df.png' },
            ],
            content: '',
            patientName: '',
        };
    },
    computed: {
        payMoney() {
            return this.active == 1 ? 5 : 1;
        },
    },
    mounted() {
        console.log();
    },
    methods: {
        getSelect(id) {
            return id == this.current;
        },
        
        queryParams() {
          
                  let params = {
                type: this.active,
                patientId: this.$store.getters.getUserInfo.patientId,
                patientName: this.patientName,
                doctorId: this.$route.query.doctorId,
                content: '',
                money: this.payMoney,
                imgUrl:'',
            };
            if (this.active == 1) {
                let item = this.editorList.find(
                    (item) => this.current == item.id,
                    (item) =>this.imgUrl ==item.id
                );
                
                params.content = item.name;
                params.imgUrl = item.imgUrl;
            } else {
                params.content = this.content;
            }
            return params;
            
          
        },
        
        submit() {
              if(this.patientName ==''){
            VanToast('请输入您的姓名或昵称');

            }else{
  
            api_recipe.saveDoctorThank(this.queryParams()).then((res) => {
                let code = res.data.data;
                this.$router.replace({
                    name: 'pay',
                    query: {
                        giftCode: code,
                        price: this.payMoney,
                        doctorId: this.$route.query.doctorId
                    },
                });
            });
            }
        },
        
    },
};
</script>

<style lang="less">
.pennant-create {
    min-height: 100vh;
    background: #f5f5f5;
    .type-wrap {
        padding: 20px 15px;
        background: white;
        margin-bottom: 5px;
        .title {
            color: #333333;
            font-size: 16px;
            margin-bottom: 20px;
        }
        .select {
            display: flex;
            .item {
                display: flex;
                flex-direction: column;
                width: 84px;
                height: 112px;
                border-radius: 2px;
                margin-right: 10px;
                justify-content: center;
                align-items: center;
                &.active {
                    background: #f4f4f4;
                }
                img {
                    width: 40px;
                    height: 59px;
                    margin-bottom: 8px;
                }
            }
        }
    }
    .gift {
        padding: 20px 15px;
        background: white;
        .title {
            color: #333333;
            font-size: 16px;
            margin-bottom: 20px;
        }
        .select {
            display: flex;
            flex-wrap: wrap;
            .item {
                width: 50%;
                margin-bottom: 25px;
                &:nth-child(even) {
                    display: flex;
                    justify-content: flex-end;
                }
            }
        }
        .editor {
            display: flex;
            justify-content: flex-end;
            .input {
                border-bottom: 1px solid #767676;
                padding: 6px 0;
            }
            input {
                margin-left: 5px;
                border: none;
                text-align: right;
                width: 98px;
            }
        }
        .descript {
            margin-bottom: 20px;
            border-radius: 2px;
            border: 1px solid #ddd;
        }
    }

    .confirm-btn {
        padding: 7px 15px 8px 15px;
        background-color: #fff;
        position: fixed;
        left: 0;
        bottom: 0;
        z-index: 9;
        width: 100%;
        box-shadow: 0px -3px 4px 0px rgba(0, 0, 0, 0.07);
        .action-button {
            background: #208fe3;
            border-radius: 4px;
            color: #ffffff;
            font-size: 18px;
            border: 0;
        }
    }
}
</style>
